import styles from "../../pages/CodesList.module.css";
import React from "react";

interface DeleteCodeModalProps {
  show: boolean;
  selectedCode: { code: string } | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteCodeModal: React.FC<DeleteCodeModalProps> = ({ show, selectedCode, onCancel, onConfirm }) => {
  if (!show || !selectedCode) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 className={styles.modalTitle}>
          האם אתה בטוח שברצונך למחוק את המספר {selectedCode.code}?
        </h3>
        <div className={styles.modalActions}>
          <button onClick={onCancel} className={styles.cancelButton}>
            ביטול
          </button>
          <button onClick={onConfirm} className={styles.deleteButton}>
            מחק
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCodeModal; 